import './index.css'
import { useEffect, KeyboardEvent } from 'react';
import { createPortal } from 'react-dom'
import { ReactComponent as CloseIcon } from '@/assets/icons/ri-close-line.svg'
import { ModalProps } from '@/components/common/Modal/types'

const Modal = ({ header, body, footer, show, onClick, rootId, contentClassName }: ModalProps)  => {
	const { children } = body
	if (!show) {
		return null
	}
	const closeOnEscapeKeyDown = (e: KeyboardEvent) => {
		if (e.key === 'Escape' || e.key === 'Esc') {
			onClick()
		}
	}
	useEffect(() => {
		document.body.addEventListener('keydown', () => closeOnEscapeKeyDown, false)
		return function cleanUp () {
			document.body.removeEventListener('keydown', () => closeOnEscapeKeyDown, false)
		}
	}, [])

	return createPortal(
		<div className="modal" onClick={(e) => {onClick(e)}} onKeyDown={closeOnEscapeKeyDown} aria-hidden>
			<div className={`modal__content ${contentClassName}`} onClick={e => e.stopPropagation()} onKeyDown={closeOnEscapeKeyDown} aria-hidden>
				<div className="modal__header">
					<h4>{header.title}</h4>
					<div role="button">
						<CloseIcon onClick={onClick()}/>
					</div>
				</div>
				<div className="modal__body">
					{children}
				</div>
				{footer && <div className='modal__footer'>
					{footer.children}
				</div>}
			</div>
		</div>,
		document.getElementById(rootId)
	)
}

export default Modal
